module.exports = __webpack_public_path__ + "img/bulletNewsImg.23ce84bd.svg";